import PoptipButton from './poptip-button'

export default PoptipButton